import olyves from "../assets/olyves.png"
import biz from "../assets/biz.png"
import sands from "../assets/sands.png"
import majorlink from "../assets/majorlink.png"
import thrive from "../assets/thrive.png"


export const navLinks = [
    {
      id: "about",
      title: "About",
      href: "#about",
    },
    {
      id: "contact",
      title: "Skills",
      href: "#skill",
    },
    {
      id: "projects",
      title: "Projects",
      href: "#projects",
    },
    {
      id: "contact",
      title: "FAQs",
      href: "#faq",
    },
    {
      id: "contact",
      title: "Contact",
      href: "#contact",
    },
   
  ];


  export const skill = [
    {
      id: "research",
      title: "User Research",
      
    },
    {
      id: "proto",
      title: "Prototyping",
      
    },
    {
      id: "wire",
      title: "Wireframing",
      
    },
    
    {
      id: "uides",
      title: "User Interface (UI) Design",
      
    },
    {
      id: "interaction",
      title: "Interaction Design",
      
    },
    {
      id: "responsive",
      title: "Responsive Design",
      
    },
    {
      id: "strategy",
      title: "Product Strategy",
      
    },
    {
      id: "centered",
      title: "User-Centered Design",
      
    },
    {
      id: "collab",
      title: "Collaboration",
      
    },
    {
      id: "access",
      title: "Accessibility",
      
    },
   
  ];

  // export const projectLinks = [
  //   {
  //     id: "featured",
  //     title: "Featured Works",
  //     current: true
  //   },
  //   {
  //       id: "personal",
  //       title: "Personal Works",
  //       current: false
  //     },
   
  // ];
  export const eachWork = [
    {
      id: "olyves",
      title: "OLYVES",
      name: "olyves",
      description: "A seamless payroll processing platform that works for Nigerian businesses, HR personnel, and employees.",
      img:olyves,
    
    },
    {
        id: "sands",
        title: "SANDS",
        name: "biz",
        description: "An online store where Nigerians may buy items created by Nigerian manufacturers both in Nigeria and the diaspora.",
        img:sands,
      
      },
      {
        id: "majorlink",
        title: "MAJORLINK",
        name: "biz",
        description: "A digital trading platform that allows you to trade your giftcards & crypto to cash instantly.",
        img:majorlink,
      
      },
      {
        id: "biz",
        title: "BIZCONVERSE",
        name: "biz",
        description: "An e-commerce revolution that bridges the gap between customers and vendors, making the entire process—from placing orders to payment—effortlessly automated and streamlined.",
        img:biz,
      
      },
      {
        id: "thrive",
        title: "THRIVE",
        name: "thrive",
        description: "Thrive app is an application that provides a platform where small business owners can easily interact, support, and collaborate with one another.",
        img:thrive,
      
      },
   
   
  ];